import React, { useState } from 'react';

import { Toolbar } from '@devexpress/dx-react-grid-material-ui';
import { Button, CircularProgress } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
import AddIcon from '@material-ui/icons/Add';
import ButtonMenu from '../../header/ButtonMenu';

const useStyles = makeStyles({
  root: {
    '& > div:first-of-type': {
      display: 'none'
    }
  }
});

const CustomToolbarRoot = ({
  children,
  onAddTime,
  timesheetOptions = [],
  onTimesheetOption,
  isAddTimeDisabled = false,
  isAddTimeLoading = false,
  ...restProps
}) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);

  return (
    <Toolbar.Root
      {...restProps}
      className={`${classes.root} tw-flex tw-flex-wrap tw-items-center tw-justify-start tw-gap-1`}
    >
      <span className="tw-mr-2 tw-flex tw-items-stretch tw-rounded tw-bg-[#3f51b5]">
        <Button
          id="add-time-btn"
          variant="contained"
          color="primary"
          className="!tw-rounded-r-none"
          startIcon={isAddTimeLoading ? <CircularProgress size={16} className="!tw-text-white" /> : <AddIcon />}
          onClick={onAddTime}
          disabled={isAddTimeDisabled}
        >
          Add Time
        </Button>
        <ButtonMenu
          buttonList={timesheetOptions}
          handleOptions={onTimesheetOption}
          setAnchorEl={setAnchorEl}
          anchorEl={anchorEl}
          disabled={isAddTimeDisabled}
        />
      </span>

      {children}
    </Toolbar.Root>
  );
};

export default CustomToolbarRoot;

CustomToolbarRoot.propTypes = {
  children: PropTypes.any,
  onAddTime: PropTypes.func,
  timesheetOptions: PropTypes.array,
  onTimesheetOption: PropTypes.func,
  isAddTimeDisabled: PropTypes.bool,
  isAddTimeLoading: PropTypes.bool
};
